export default __webpack_public_path__ + "static/media/image.4be4e5aa.jpg";